import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from '@/hooks/use-auth';
import { AppShell } from '@/components/layout/AppShell';
import Login from '@/pages/Login';
import Dashboard from '@/pages/Dashboard';
import LookupPage from '@/pages/Lookup';
import Composer from '@/pages/Composer';
import History from '@/pages/History';
import Settings from '@/pages/Settings';
import Admin from '@/pages/Admin';

function Protected({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground">
      Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export default function App() {
  return (
    <AuthProvider>
    <BrowserRouter>
    <Routes>
    <Route path="/login" element={<Login />} />
    <Route
    path="/"
    element={
      <Protected>
      <AppShell />
      </Protected>
    }
    >
    <Route index element={<Dashboard />} />
    <Route path="lookup" element={<LookupPage />} />
    <Route path="composer" element={<Composer />} />
    <Route path="history" element={<History />} />
    <Route path="settings" element={<Settings />} />
    <Route path="admin" element={<Admin />} />
    </Route>
    {/* catch-all LAST — outside the layout route */}
    <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    </BrowserRouter>
    </AuthProvider>
  );
}
